import { useEffect, useState } from "react";
import styled from "styled-components";

const ContentLeft = styled.div`
  width: 90%;
  padding:2em;
  text-align: left;
  color: black;
  padding-top:0px;
  text-decoration: none;
  a {
    text-decoration: none;
  }
  a:visited {
    color: #3333cc;
  }
  a:hover, a:visited:hover {
    color: #cc33cc;
  }
`;

const Secret = () => {
  const [responseData, setResponseData] = useState(null);
  useEffect(() => {
    let responseData;
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Basic cHJpdmF0ZV9YYTVzUG9IcVg2SG5Wa0FnbEl3eGU1SjRkSFE9Og==");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch("https://api.imagekit.io/v1/files?tags=2025-02-14", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setResponseData(JSON.parse(result)[0].url);
        // console.log(JSON.parse(result)[0].url);
      })
      .catch((error) => console.error(error));
    // let responseData;
    // const myHeaders = new Headers();
    // myHeaders.append("Accept", "application/json");
    // myHeaders.append("Authorization", "Key private_Xa5sPoHqX6HnVkAglIwxe5J4dHQ=");

    // const requestOptions = {
    //   method: "GET",
    //   headers: myHeaders,
    //   redirect: "follow"
    // };

    // fetch("https://ik.imagekit.io/ianellis/IMG-20250214-WA0008.jpg?updatedAt=1748733559420", requestOptions)
    //   .then((response) => response.text())
    //   .then((result) => {
    //     setResponseData(result);
    //   })
    //   .catch((error) => console.error(error));
  }, []);  
  return(
    <ContentLeft>
      {/* {responseData && <img src="https://ik.imagekit.io/ianellis/i11.jpg?updatedAt=1748733559214"></img> } lalal */}
      {/* {responseData && <div>{responseData}</div> } lalal */}

      {responseData && <img src={responseData}></img>} lalal
    </ContentLeft>
  )
};
  
export default Secret;